module.exports = __webpack_public_path__ + "img/HA1501-25.7a6651f7.jpg";